import React from 'react';
import { Card } from "react-bootstrap";
import face_luca_szegletes from "../../assets/img/face_luca_szegletes.png";
import ShowMoreText from "react-show-more-text";
import proj_brain_imaging from "../../assets/img/proj_brain_imaging.png";

const Luca_Szegletes_brain_imaging = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_brain_imaging} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_luca_szegletes}
              /* this will be the text on the banner */
              alt="When is One Dataset Comparable to Another? Harmonising Multi-Site Brain Imaging Data"
            />{" "}
            <p className="text7">Luca Szegletes</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Department of Automation and Applied Informatics, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Suppose two hospitals measure the same quantity in the same way on comparable
            populations, and you pool their data. A classifier trained on the pooled dataset will often
            identify the hospital far more accurately than the medical condition you actually care about.
            This is not a hypothetical: in multi-site functional MRI studies, the scanner and the acquisition
            protocol leave a signature in the data that is larger than the biological signal.
            <br />
            <br />
            The mathematical question underneath is a nice one. Two datasets differ by two things at
            once: a nuisance transformation you want to remove, and a genuine difference in the
            populations you want to keep. Nothing in the data itself labels which is which. Any correction
            procedure must therefore rest on an assumption that site effects act only on the mean and
            variance, that they act identically on all subjects, that the populations are exchangeable and
            different assumptions give genuinely different answers. The project is about taking those
            assumptions seriously.
            <br />
            <br />
            Concretely, you will work with public multi-site fMRI datasets (ABIDE, ADHD-200), where
            each subject is summarised by a functional connectivity matrix, a symmetric positive definite
            matrix, so the natural geometry is not Euclidean, which is itself part of the problem. You will
            first <i>measure</i> the site effect, then try to remove it, then check honestly whether you removed
            the biology along with it. That last step is where most published methods are weakest, and
            where a mathematically careful student can contribute something real.
            Possible directions, to be chosen together in the first weeks:
            <br />
            <br />
            Possible directions:
            <br />
            
            <ul>
              <li>
                Compare existing harmonisation methods under controlled conditions where you
                know the ground truth, by simulating site effects yourself.
              </li>
              <li>
                Develop a method that works with the SPD geometry of connectivity matrices rather
                than against it.
              </li>
              <li>
                Formulate a criterion that separates "site effect removed" from "signal destroyed", and
                use it as a diagnostic.
              </li>
            </ul>
            No neuroscience background is expected, you are free to choose the mathematical or machine
            learning tools you find most natural, and part of the work is deciding what those should be.
            <br />
            <br />
            <b>Prerequisites:</b> Probability and statistics, linear algebra, maybe machine learning/deep
            learning. Python programming. Interest in working with real, messy data. Curiosity and
            persistence matter more than any of the prerequisites listed above.
            <br/>
            <br/>
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://www.frontiersin.org/journals/neurology/articles/10.3389/fneur.2022.923988/full">Bayer, J. M. M., Thompson, P. M., Ching, C. R. K., Liu, M., Chen, A., Panzenhagen, A. C., … Sämann, P. G. (2022).
                Site effects how-to and when: An overview of retrospective techniques to accommodate site effects in multi-site neuroimaging analyses. 
                Frontiers in Neurology, 13–2022. doi:10.3389/fneur.2022.923988</a>
                </li>
            
            </ul>

            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Luca_Szegletes_brain_imaging;